export default "__VITE_ASSET__NAqugpy6__"